import gql from "graphql-tag";

export const MY_PROJECTS = gql`
  query myProjects {
    getMyProjects {
      id
      name
      slug
      description
      updatedAt
    }
  }
`;

export const GET_PROJECT_SLUG = gql`
  query getProjectBySlug($slug: String!) {
    getProjectBySlug(slug: $slug) {
      id
      name
      slug
      updatedAt
      workflows {
        id
        slug
        unauthorized_roles
        protectedby
      }
      relationalModel {
        id
        models
        associations
      }
      roles
    }
  }
`;

export const NEW_PROJECT = gql`
  mutation newProject($project: ProjectInput!) {
    createProject(project: $project) {
      id
      name
      slug
    }
  }
`;

export const DELETE_PROJECT = gql`
  mutation deleteProject($id: String!) {
    deleteProject(id: $id)
  }
`;

export const NEW_WORKFLOW = gql`
  mutation createWorkflow($projectId: String!, $input: WorkflowInfoInput!) {
    createWorkflow(projectId: $projectId, input: $input) {
      id
      slug
    }
  }
`;

export const GET_WORKFLOW = gql`
  query getWorkflow($id: String!) {
    getWorkflow(id: $id) {
      id
      slug
      content
      master_content
    }
  }
`;

export const GET_MODEL = gql`
  query getRelationalModel($projectId: String!) {
    getRelationalModel(projectId: $projectId) {
      id
      models
      associations
    }
  }
`;

export const SAVE_WORKFLOW = gql`
  mutation saveWorkflow($id: String!, $newContent: String!) {
    saveWorkflow(id: $id, newContent: $newContent)
  }
`;

export const DEPLOY_WORKFLOWS = gql`
  mutation deployWorkflows($ids: [String]!) {
    deployWorkflows(ids: $ids)
  }
`;

export const SAVE_MODEL = gql`
  mutation saveRelationalModel(
    $id: String!
    $relationalModel: RelationalModelInput!
  ) {
    saveRelationalModel(id: $id, relationalModel: $relationalModel)
  }
`;

export const DEPLOY_MODEL = gql`
  mutation deployRelationalModel($id: String!) {
    deployRelationalModel(id: $id)
  }
`;

export const EDIT_PROJECT_ROLES = gql`
  mutation editProjectRoles($id: String!, $roles: [String]) {
    editProjectRoles(id: $id, roles: $roles) {
      id
      roles
    }
  }
`;

export const EDIT_WORKFLOWS_ROLES = gql`
  mutation editWorkflowsRoles($workflows: [WorkflowRoleInput]!) {
    editWorkflowsRoles(workflows: $workflows)
  }
`;

export const GET_PROJECT_KEYS = gql`
  query getProjectKeys($projectId: String!) {
    getProjectKeys(projectId: $projectId) {
      id
      key
      roles
      whitelist
      enviroments
    }
  }
`;

export const CREATE_PROJECT_KEY = gql`
  mutation createKey(
    $projectId: String!
    $roles: [String]
    $domains: [String]
    $enviroments: [String]
  ) {
    createKey(
      projectId: $projectId
      roles: $roles
      domains: $domains
      enviroments: $enviroments
    ) {
      id
      key
      roles
      whitelist
      enviroments
    }
  }
`;

export const EDIT_PROJECT_KEY = gql`
  mutation editKey(
    $id: String!
    $roles: [String]
    $domains: [String]
    $enviroments: [String]
  ) {
    editKey(
      id: $id
      roles: $roles
      domains: $domains
      enviroments: $enviroments
    )
  }
`;

export const DELETE_PROJECT_KEY = gql`
  mutation deleteKey($id: String!) {
    deleteKey(id: $id)
  }
`;
